import { AppRoute } from "./app-routes";
import common from "../i18n/definitions/common";

export const yhteydenottoRoutes = {
  categories: [
    {
      anchor: "Yhteydenotto",
      components: [
        {
          anchor: "Link",
          name: "SitemapLink",
          properties: {
            route: AppRoute.Yhteydenotto,
            text: common.yhteydenotto
          }
        }
      ]
    }
  ]
};
